enum Action {
  Open,
  Close,
}

enum Layer {
  Base,
  Slide,
}

let timeoutHandler = 0;

export default function menuInit() {
  document.addEventListener("DOMContentLoaded", function () {
    console.debug("Init Menu");
    const menu = document.getElementById("menu-container");
    menu?.classList.add("animate");

    document
      .getElementById("raseborg-menu-button")
      ?.addEventListener("click", () => toggleMenu(true));
    document
      .getElementById("raseborg-menu-close")
      ?.addEventListener("click", () => toggleMenu(false));
    document
      .getElementById("raseborg-menu-home")
      ?.addEventListener("click", function () {
        transitionMenu("root", Action.Close);
      });
  });
}

function toggleMenu(open: boolean) {
  const menu = document.getElementById("menu-container");
  if (open) {
    document.body.classList.add("noscroll");
    clearTimeout(timeoutHandler);
    displayMenu(menu?.dataset.current ?? "root");
    disableButton("raseborg-menu-close", false);
    menu?.classList.add("open");
  } else {
    document.body.classList.remove("noscroll");
    menu?.classList.remove("open");
    timeoutHandler = setTimeout(function () {
      displayMenu("empty");
      disableButton("raseborg-menu-close", true);
    }, 300);
  }
}

function disableButton(id: string, disabled: boolean) {
  const button = document.getElementById(id);
  if (button instanceof HTMLButtonElement) {
    button.disabled = disabled;
  }
}

function transitionMenu(id: string, action: Action = Action.Open) {
  const menu = document.getElementById("menu-container");
  const base = document.getElementById("base-menu");
  const slide = document.getElementById("slide-menu");
  if (
    base instanceof HTMLElement &&
    slide instanceof HTMLElement &&
    menu instanceof HTMLElement
  ) {
    menu.dataset.current = id;
    switch (action) {
      // Open menu animation.
      case Action.Open:
        slide.classList.add("right");
        slide.classList.add("animate");
        // Write the new menu content to the slide layer.
        displayMenu(id, Layer.Slide);
        slide.classList.add("show");
        setTimeout(function () {
          slide.classList.remove("right");
          // Wait for transition to finish.
          setTimeout(function () {
            // Write menu content to the real menu layer.
            displayMenu(id, Layer.Base);

            // Hide and clean up the slide layer.
            slide.classList.remove("show");
            slide.classList.remove("animate");
          }, 300);
        }, 50);
        break;

      // Close menu animation.
      case Action.Close:
        // Remove class just in case.
        slide.classList.remove("right");

        // Set the required classes.
        slide.classList.add("animate");
        // Copy base menu content to slide layer.
        copyMenu(base, slide);
        slide.classList.add("show");

        // set the new menu underneath.
        displayMenu(id, Layer.Base);

        setTimeout(function () {
          slide.classList.add("right");

          // Wait for transition to finish.
          setTimeout(function () {
            // Hide and clean up the slide layer.
            slide.classList.remove("show");
            slide.classList.remove("animate");
            slide.classList.remove("right");
          }, 300);
        }, 50);
        break;
    }
  }
}

function displayMenu(id: string, layer: Layer = Layer.Base) {
  const menu = document.getElementById(
    layer === Layer.Base ? "base-menu" : "slide-menu",
  );
  const home = document.getElementById("raseborg-menu-home");
  if (!menu) return;
  const template = document.getElementById(`template-${id}`);
  if (!template) {
    emptyMenu(menu);
    return;
  }
  copyMenu(template, menu);
  if (layer === Layer.Base) {
    activateButtons(menu);
    if (home) {
      if (id === "root") {
        home.classList.add("hide");
      } else {
        home.classList.remove("hide");
      }
    }
  }
}

function copyMenu(from: Node, to: Node) {
  emptyMenu(to);
  for (const node of from.childNodes) {
    to.appendChild(node.cloneNode(true));
  }
}

function emptyMenu(menu: Node) {
  while (menu.firstChild) {
    menu.removeChild(menu.firstChild);
  }
}

function activateButtons(menu: HTMLElement) {
  const openButtons = menu.querySelectorAll("[data-menu-open]");
  for (const button of openButtons) {
    if (button instanceof HTMLElement) {
      const id = button.dataset.menuOpen;
      if (id) {
        button.addEventListener("click", () =>
          transitionMenu(
            id,
            button.classList.contains("open") ? Action.Open : Action.Close,
          ),
        );
      }
    }
  }
}
